import React from "react";
import {SceneEditor} from "./SceneEditor";
import classnames from "classnames";
import "./SceneExplorerAppWrapper.scss";
import {useLocalStorage} from "oc-ui/react/useLocalStorage";
import UniversalLoader from "oc-threejs/loader/UniversalLoader";

// @ts-ignore
export function SceneEditorAppWrapper({sceneNode, children, axisLabeled = false, isAdmin}) {

    const [editMode, _setEditMode] = useLocalStorage('sceneEditorOpen', false);

    const setEditMode = (x) => {
        _setEditMode(x);
        APP.trigger('SceneEditorEditModeChange', x);
        _.delay(() => STAGE.setRendererToSize(), 500);
    }

    if (isAdmin) {

        const editorShown = sceneNode != null && editMode;

        if (editorShown) {
            UniversalLoader.cacheEnabled = false;
        }

        return (
            <div
                className={classnames("scene-editor-app-wrapper fullsize", editorShown && 'edit-mode')}>
                <div id="cfg-app">
                    {children}
                </div>
                {editorShown
                    ? (
                        <SceneEditor
                            sceneNode={sceneNode}
                            // @ts-ignore
                            axisLabeled={axisLabeled}
                            closeButton={() => (
                                <div className="close button"
                                     onClick={() => setEditMode(false)}
                                     title="Scene Editor schliessen">
                                    ✖
                                </div>
                            )}
                        />
                    )
                    : (
                        <div className="scene-editor-open-button"
                             title="Scene Editor öffnen"
                             onClick={() => setEditMode(true)}>
                            ⋮
                        </div>
                    )}
            </div>
        );
    }

    return (
        <div id="cfg-app" className="fullsize">
            {children}
        </div>
    );

}
